import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import { useMeta } from 'vue-meta'

export default {
  setup () {
    useMeta({
      title: 'aaa',
      htmlAttrs: { lang: 'pl', amp: true }
    })
  },  
  name: 'App',
  metaInfo: { 
    title: 'tomasz', 
    meta: [ { 
      name: 'bla-bla', 
      content: 'This is a description of my page' }, 
      { name: 'keywords', 
        content: 'vue, meta, seo' } ] },
  components: {
  },
  methods: {
    showModal() {
      //$('#myModal').modal('show'); 
    },
    handleResize() {
      new Promise(resolve => setTimeout(resolve, 2000));
      console.log(window.innerWidth);
      var img1 = document.getElementById('img1');
      var img2 = document.getElementById('img2');
      var img3 = document.getElementById('img3');
      var img4 = document.getElementById('img4');
      var img5 = document.getElementById('img5');
      var img6 = document.getElementById('img6');
      var img7 = document.getElementById('img7');
      var img8 = document.getElementById('img8');
      var img9 = document.getElementById('img9');
      var img10 = document.getElementById('img10');
      var img11 = document.getElementById('img11');
      var img12 = document.getElementById('img12');

      var img101 = document.getElementById('img101');
      var img102 = document.getElementById('img102');
      var img103 = document.getElementById('img103');
      var img104 = document.getElementById('img104');
      var img105 = document.getElementById('img105');
      var img106 = document.getElementById('img106');
      var img107 = document.getElementById('img107');
      var img108 = document.getElementById('img108');
      var img109 = document.getElementById('img109');
      var img110 = document.getElementById('img110');
      var img111 = document.getElementById('img111');
      var img112 = document.getElementById('img112');
      var sizes = '50%'
      if (window.innerWidth < 500) {
        img1.style.width = sizes;
        img2.style.width = sizes;
        img3.style.width = sizes;
        img4.style.width = sizes;
        img5.style.width = sizes;
        img6.style.width = sizes;
        img7.style.width = sizes;
        img8.style.width = sizes;
        img9.style.width = sizes;
        img10.style.width = sizes;
        img11.style.width = sizes;
        img12.style.width = sizes;

        img1.width = sizes;
        img2.width = sizes;
        img3.width = sizes;
        img4.width = sizes;
        img5.width = sizes;
        img6.width = sizes;
        img7.width = sizes;
        img8.width = sizes;
        img9.width = sizes;
        img10.width = sizes;
        img11.width = sizes;
        img12.width = sizes;

        img101.style.width = sizes;
        img102.style.width = sizes;
        img103.style.width = sizes;
        img104.style.width = sizes;
        img105.style.width = sizes;
        img106.style.width = sizes;
        img107.style.width = sizes;
        img108.style.width = sizes;
        img109.style.width = sizes;
        img110.style.width = sizes;
        img111.style.width = sizes;
        img112.style.width = sizes;

        img101.width = sizes;
        img102.width = sizes;
        img103.width = sizes;
        img104.width = sizes;
        img105.width = sizes;
        img106.width = sizes;
        img107.width = sizes;
        img108.width = sizes;
        img109.width = sizes;
        img110.width = sizes;
        img111.width = sizes;
        img112.width = sizes;
      }
      else if (window.innerWidth < 1000) {
        img1.style.width = sizes;
        img2.style.width = sizes;
        img3.style.width = sizes;
        img4.style.width = sizes;
        img5.style.width = sizes;
        img6.style.width = sizes;
        img7.style.width = sizes;
        img8.style.width = sizes;
        img9.style.width = sizes;
        img10.style.width = sizes;
        img11.style.width = sizes;
        img12.style.width = sizes;

        img1.width = sizes;
        img2.width = sizes;
        img3.width = sizes;
        img4.width = sizes;
        img5.width = sizes;
        img6.width = sizes;
        img7.width = sizes;
        img8.width = sizes;
        img9.width = sizes;
        img10.width = sizes;
        img11.width = sizes;
        img12.width = sizes;

                img101.style.width = sizes;
        img102.style.width = sizes;
        img103.style.width = sizes;
        img104.style.width = sizes;
        img105.style.width = sizes;
        img106.style.width = sizes;
        img107.style.width = sizes;
        img108.style.width = sizes;
        img109.style.width = sizes;
        img110.style.width = sizes;
        img111.style.width = sizes;
        img112.style.width = sizes;

        img101.width = sizes;
        img102.width = sizes;
        img103.width = sizes;
        img104.width = sizes;
        img105.width = sizes;
        img106.width = sizes;
        img107.width = sizes;
        img108.width = sizes;
        img109.width = sizes;
        img110.width = sizes;
        img111.width = sizes;
        img112.width = sizes;
      }
      else if (window.innerWidth < 1500) {
        sizes = '25%'
        img1.style.width = sizes;
        img2.style.width = sizes;
        img3.style.width = sizes;
        img4.style.width = sizes;
        img5.style.width = sizes;
        img6.style.width = sizes;
        img7.style.width = sizes;
        img8.style.width = sizes;
        img9.style.width = sizes;
        img10.style.width = sizes;
        img11.style.width = sizes;
        img12.style.width = sizes;

        img1.width = sizes;
        img2.width = sizes;
        img3.width = sizes;
        img4.width = sizes;
        img5.width = sizes;
        img6.width = sizes;
        img7.width = sizes;
        img8.width = sizes;
        img9.width = sizes;
        img10.width = sizes;
        img11.width = sizes;
        img12.width = sizes;

        img101.style.width = sizes;
        img102.style.width = sizes;
        img103.style.width = sizes;
        img104.style.width = sizes;
        img105.style.width = sizes;
        img106.style.width = sizes;
        img107.style.width = sizes;
        img108.style.width = sizes;
        img109.style.width = sizes;
        img110.style.width = sizes;
        img111.style.width = sizes;
        img112.style.width = sizes;

        img101.width = sizes;
        img102.width = sizes;
        img103.width = sizes;
        img104.width = sizes;
        img105.width = sizes;
        img106.width = sizes;
        img107.width = sizes;
        img108.width = sizes;
        img109.width = sizes;
        img110.width = sizes;
        img111.width = sizes;
        img112.width = sizes;
      }
      else if (window.innerWidth < 2000) {
        sizes = '20%'
        img1.style.width = sizes;
        img2.style.width = sizes;
        img3.style.width = sizes;
        img4.style.width = sizes;
        img5.style.width = sizes;
        img6.style.width = sizes;
        img7.style.width = sizes;
        img8.style.width = sizes;
        img9.style.width = sizes;
        img10.style.width = sizes;
        img11.style.width = sizes;
        img12.style.width = sizes;

        img1.width = sizes;
        img2.width = sizes;
        img3.width = sizes;
        img4.width = sizes;
        img5.width = sizes;
        img6.width = sizes;
        img7.width = sizes;
        img8.width = sizes;
        img9.width = sizes;
        img10.width = sizes;
        img11.width = sizes;
        img12.width = sizes;

        img101.style.width = sizes;
        img102.style.width = sizes;
        img103.style.width = sizes;
        img104.style.width = sizes;
        img105.style.width = sizes;
        img106.style.width = sizes;
        img107.style.width = sizes;
        img108.style.width = sizes;
        img109.style.width = sizes;
        img110.style.width = sizes;
        img111.style.width = sizes;
        img112.style.width = sizes;

        img101.width = sizes;
        img102.width = sizes;
        img103.width = sizes;
        img104.width = sizes;
        img105.width = sizes;
        img106.width = sizes;
        img107.width = sizes;
        img108.width = sizes;
        img109.width = sizes;
        img110.width = sizes;
        img111.width = sizes;
        img112.width = sizes;
      }
      else {

        sizes = '20%'
        img1.style.width = sizes;
        img2.style.width = sizes;
        img3.style.width = sizes;
        img4.style.width = sizes;
        img5.style.width = sizes;
        img6.style.width = sizes;
        img7.style.width = sizes;
        img8.style.width = sizes;
        img9.style.width = sizes;
        img10.style.width = sizes;
        img11.style.width = sizes;
        img12.style.width = sizes;

        img1.width = sizes;
        img2.width = sizes;
        img3.width = sizes;
        img4.width = sizes;
        img5.width = sizes;
        img6.width = sizes;
        img7.width = sizes;
        img8.width = sizes;
        img9.width = sizes;
        img10.width = sizes;
        img11.width = sizes;
        img12.width = sizes;

        img101.style.width = sizes;
        img102.style.width = sizes;
        img103.style.width = sizes;
        img104.style.width = sizes;
        img105.style.width = sizes;
        img106.style.width = sizes;
        img107.style.width = sizes;
        img108.style.width = sizes;
        img109.style.width = sizes;
        img110.style.width = sizes;
        img111.style.width = sizes;
        img112.style.width = sizes;

        img101.width = sizes;
        img102.width = sizes;
        img103.width = sizes;
        img104.width = sizes;
        img105.width = sizes;
        img106.width = sizes;
        img107.width = sizes;
        img108.width = sizes;
        img109.width = sizes;
        img110.width = sizes;
        img111.width = sizes;
        img112.width = sizes;
      }
    },
    imageLoaded() {

    }
  },
  mounted() {
    this.handleResize();
  }
}